import React, { Fragment, useEffect, useState } from "react";
import Ripple from "../../../../../common/component/Ripple";
import { Icon, message } from "antd";
import { Modal } from "antd";
import Wrapper from "../../../../../common/component/Wrapper";
import {
  FormActionComponent,
  FormWrapperInputComponent,
} from "../../../../../common/component/Index";
import AntSelect, {
  AntOption,
} from "../../../../../common/component/AntSelect";
import {
  capitalizeFirstLetter,
  formatValidation,
  multipleValidate,
} from "../../../../../../../helpers/functions";
import { useTranslation } from "react-i18next";
import Select from "../../../../../common/component/Select";
import { cloneDeep, set } from "lodash";
import CheckboxGroup from "antd/lib/checkbox/Group";
import * as RateService from "../../../../../../../services/rateService";
import { TARGET_LANGUAGE_DATA } from "constants/Define";
const AutoTranslateModal = (props) => {
  const { handleCancel = () => {}, item, getListRates } = props;
  const { t } = useTranslation();
  const { translations } = item;

  const sourceLanguageBase = [
    {
      name: "Tiếng Việt",
      value: "vi-VN",
    },
    {
      name: "Tiếng Anh",
      value: "en-US",
    },
  ];

  const targetLanguageData = TARGET_LANGUAGE_DATA;

  //! State
  const [visible, setVisible] = useState(true);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [validation, setValidation] = useState({});
  const [dataSourceLanguage, setDataSourceLanguage] =
    useState(sourceLanguageBase);
  const [data, setData] = useState({
    hotelId: item && item?.hotelId,
    ratePlanId: item && item?.id,
    sourceLanguage: "vi-VN",
    targetLanguage: [],
  });

  useEffect(() => {
    let sourceLanguageData = cloneDeep(sourceLanguageBase);
    const languageCodeTranslations = translations.map((el) => el.languageCode);
    const isHasVI = languageCodeTranslations.includes("vi-VN");
    const isHasEN = languageCodeTranslations.includes("en-US");
    if (isHasVI && isHasEN) {
      return setDataSourceLanguage(sourceLanguageData);
    }
    if (isHasEN) {
      return setDataSourceLanguage([
        sourceLanguageData.find((el) => el.value !== "vi-VN"),
      ]);
    }
    if (isHasVI) {
      return setDataSourceLanguage([
        sourceLanguageData.find((el) => el.value !== "en-US"),
      ]);
    }
    return sourceLanguageData;
  }, [translations]);

  useEffect(() => {
    return () => {
      setData({
        hotelId: "",
        ratePlanId: "",
        sourceLanguage: "vi-VN",
        targetLanguage: [],
      });
    };
  }, []);

  const validate = () => {
    let validate = {
      minLength: {
        targetLanguage: "Vui lòng chọn ít nhất 1 ngôn ngữ",
      },
    };
    let valueValidate = {
      minLength: {
        targetLanguage: 1,
      },
    };
    const result = multipleValidate(data, validate, valueValidate);
    setValidation(result);
    return Object.keys(result).length < 1;
  };

  //! Function
  const onChangeSourceLanguage = (type) => {
    let dataSourceLanguage = cloneDeep(data);
    if (type === "en-US") {
      const targetLanguage =
        dataSourceLanguage.targetLanguage &&
        dataSourceLanguage.targetLanguage.filter((item) => item !== "en-US");
      dataSourceLanguage.targetLanguage = targetLanguage;
    }
    dataSourceLanguage.sourceLanguage = type;
    return setData(dataSourceLanguage);
  };

  const onChangeTargetLanguage = (value) => {
    const dataTargetLanguage = cloneDeep(data);
    dataTargetLanguage.targetLanguage = value;
    return setData(dataTargetLanguage);
  };

  const handleOk = async () => {
    if (validate()) {
      setConfirmLoading(true);
      try {
        const res = await RateService.autoTransalate({
          sourceId: data.ratePlanId,
          targetLanguages: data.targetLanguage,
          sourceLanguage: data.sourceLanguage,
        });
        if (res) {
          setConfirmLoading(false);
          message.success("Translate thành công");
          handleCancel();
          getListRates();
          return;
        }
      } catch (error) {
        const messageError = error && error?.data?.errors?.[0]?.message;
        return message.error(messageError);
      }
    }
    return;
  };
  //! Render
  return (
    <Fragment>
      {/* Modal */}
      <Modal
        confirmLoading={confirmLoading}
        title={"Auto Translate"}
        okText={"Translate"}
        width={800}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        maskClosable={false}
      >
        <Wrapper className="m-b">
          <FormWrapperInputComponent
            placeholder={capitalizeFirstLetter(
              t("placeHolderForm.select").toLowerCase()
            )}
            messageBelowInput={true}
            labelTitle={"Ngôn ngữ nguồn:"}
          >
            <AntSelect
              value={data.sourceLanguage}
              style={{ width: "250px", padding: "0 20px" }}
              onChange={(type) => onChangeSourceLanguage(type)}
            >
              {dataSourceLanguage.map((el) => (
                <AntOption key={el.value} value={el.value}>
                  {el.name}
                </AntOption>
              ))}
            </AntSelect>
          </FormWrapperInputComponent>

          <FormWrapperInputComponent
            isRequired={true}
            isValidation={true}
            messageBelowInput={true}
            validation={validation.targetLanguage}
            labelTitle={"Ngôn ngữ mong muốn tự động dịch sang:"}
          >
            <CheckboxGroup
              style={{ width: "100%" }}
              className="m-t"
              options={
                data.sourceLanguage === "en-US"
                  ? targetLanguageData.filter((item) => item.value !== "en-US")
                  : targetLanguageData
              }
              value={data.targetLanguage}
              onChange={(checkedValue) => onChangeTargetLanguage(checkedValue)}
            />
          </FormWrapperInputComponent>
        </Wrapper>
      </Modal>
    </Fragment>
  );
};

export default AutoTranslateModal;
